import { LogIn, PartyPopper } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";


interface PostCheckoutLoginModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function PostCheckoutLoginModal({
  open,
  onOpenChange,
}: PostCheckoutLoginModalProps) {
  const handleLogin = () => {
    window.location.href = `/login?returnTo=${encodeURIComponent(window.location.pathname + window.location.search)}`;
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md bg-card border-border">
        <DialogHeader>
          <div className="flex justify-center mb-2">
            <div className="p-3 rounded-full bg-primary/10">
              <PartyPopper className="w-8 h-8 text-primary" />
            </div>
          </div>
          <DialogTitle className="text-xl font-bold text-foreground text-center">
            Payment successful!
          </DialogTitle>
          <DialogDescription className="text-muted-foreground text-center">
            Log in now to enjoy your benefits and start following your favorite influencers.
          </DialogDescription>
        </DialogHeader>

        <Button onClick={handleLogin} className="w-full gap-2 mt-2">
          <LogIn className="w-4 h-4" />
          Log in now
        </Button>

        <button
          onClick={() => onOpenChange(false)}
          className="text-xs text-muted-foreground hover:text-foreground text-center transition-colors"
        >
          I'll do this later
        </button>
      </DialogContent>
    </Dialog>
  );
}
